import { render, staticRenderFns } from "./UploadISADialog.vue?vue&type=template&id=2a5fbfe3&scoped=true"
import script from "./UploadISADialog.vue?vue&type=script&lang=js"
export * from "./UploadISADialog.vue?vue&type=script&lang=js"
import style0 from "./UploadISADialog.vue?vue&type=style&index=0&id=2a5fbfe3&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fbfe3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5fbfe3')) {
      api.createRecord('2a5fbfe3', component.options)
    } else {
      api.reload('2a5fbfe3', component.options)
    }
    module.hot.accept("./UploadISADialog.vue?vue&type=template&id=2a5fbfe3&scoped=true", function () {
      api.rerender('2a5fbfe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UploadISADialog.vue"
export default component.exports